export const beforeInstallTemplate = 
`Describe the issue you’re having and any details about your environment to help us understand the scenario.

## Version and Channel of Visual Studio
<Please describe what versions and channels of Visual Studio you’re using>

## Network or environment situation
<E.g. Are you using a layout?  Are you using Administrator updates?>

## Description of the problem
<Please enter detailed repro steps and any other pertinent details necessary for us to help troubleshoot>

## Do you want subsequent conversation to be private?
<Let us know if we need to follow up in a more private manner>
`;
